import { render, staticRenderFns } from "./ReferenceFactImport.vue?vue&type=template&id=443c25f0&scoped=true"
import script from "./ReferenceFactImport.vue?vue&type=script&lang=js"
export * from "./ReferenceFactImport.vue?vue&type=script&lang=js"
import style0 from "./ReferenceFactImport.vue?vue&type=style&index=0&id=443c25f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443c25f0",
  null
  
)

export default component.exports